import { Injectable } from "@angular/core";
import { Subject, BehaviorSubject } from "rxjs";
// import { HttpClientService } from "../http-client";
import { map } from "rxjs/operators";
import { HttpHeaders, HttpClient } from "@angular/common/http";
import { HttpClientService } from "src/app/core/http/http-client";

@Injectable({
  providedIn: 'root'
})
export class UtilityService {

  private showbackButton = new BehaviorSubject(false);
  public showbackButton$ = this.showbackButton.asObservable()
  public trackingData = new BehaviorSubject({});
  public trackingData$ = this.trackingData.asObservable()
  private scrollToTop = new Subject<boolean>()
  public scrollToTop$ = this.scrollToTop.asObservable()
  private tabSelection = new Subject<string>();
  public tabSelection$ = this.tabSelection.asObservable();
  private destroyComponent = new Subject<boolean>()
  public destroyComponent$ = this.destroyComponent.asObservable()
  private clickedIndex = new Subject<any>();
  public clickedIndex$ = this.clickedIndex.asObservable();
  private arrayType = new Subject<string>()
  public arrayType$ = this.arrayType.asObservable()
  private pauseJwPlayer = new Subject<boolean>()
  public pauseJwPlayer$ = this.pauseJwPlayer.asObservable()

  private assessmentFeedbacks = new BehaviorSubject({});
  assessmentFeedbacks$ = this.assessmentFeedbacks.asObservable();


  setAssessmentFeedbacks(val) {
    this.assessmentFeedbacks.next(val)
  }
  constructor(private http: HttpClientService, private httpDl: HttpClient) { }

  setModuleNavigationData(type, id) {
    localStorage.setItem("navigateToContent", JSON.stringify({ type, id }))
  }
  setNotesNavigationData(id, time, noteId) {
    localStorage.setItem("navigateToContent", JSON.stringify({ id, time, noteId }))
  }
  removeNavigationData() {
    localStorage.removeItem("navigateToContent");
  }
  getContentData() {
    return JSON.parse(localStorage.getItem("navigateToContent"));
  }

  isNavigateToContentExists() {
    return localStorage.getItem("navigateToContent") ? true : false;
  }

  selectTab(tab: any) {
    this.tabSelection.next(tab);
  }

  downloadVtt(url) {
    let headers = new HttpHeaders();
    headers = headers.set('Accept', 'application/vtt');
    return this.httpDl.get(url, { headers: headers, responseType: 'blob' });
  }


  set isBackRequired(val) {
    this.showbackButton.next(val)
  }

  set TrackingData(val) {
    // console.log(val)
    this.trackingData.next(val)
  }

  get TrackData() {
  //  console.log(this.trackingData);
    return this.trackingData;
  }



  set destroyResultComponent(val) {
    this.destroyComponent.next(val)
  }
  set scrollToTopFun(val) {
    this.scrollToTop.next(val)
  }

  set barClickedIndex(val) {
  this.clickedIndex.next(val)
  }

  get pillarClickedIndex() {
    return this.clickedIndex$;
  }

  set barArrayType(val) {
    this.arrayType.next(val);
  }

  get pillarArrayType() {
    return this.arrayType$;
  }

  uploadFile(resources) {
    return this.http.post<{ data: string }>('/utils/upload-file', resources).pipe(
      map(res => res.data)
    )
  }


  checkAnswers(resources) {
    return this.http.post<{ data: any[] }>('users/checkblankanswer', resources).pipe(
      map(res => res.data)
    )
  }

  evaluateQuestion(answer) {
    return this.http.post<{ data: any }>('users/evalute-single-questions', answer).pipe(
      map(res => res.data)
    )
  }


  updateEngagement(eventType = 'EntusiasticAdoption', subEventType = '', points = 3) {
    return this.http.post<{ data: any, result: number, msg: string }>('userEngagementMetric/save', {eventType, subEventType, points }).pipe(map(res => {
      return res;
    }
    ));
  }
  updateCourseEngagement(courseId,eventType = 'EntusiasticAdoption', subEventType = '', points = 3) {
    return this.http.post<{ data: any, result: number, msg: string }>('userEngagementMetric/save', {courseId,eventType, subEventType, points }).pipe(map(res => {
      return res;
    }
    ));
  }

  sendBusinessQuery(data) {
    return this.http.post<{ data: string }>('utils/business-contact', data).pipe(map(res => res.data));
  }

  set shouldPlayerStop(val) {
    ;
    this.pauseJwPlayer.next(val)
  }

}
